import * as _ from 'underscore'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../user-session'
import { OpOperator, OpRoute } from '../../models/core'
import { ColumnModel } from '../../modules/api/api.models'
import { LocalizationHelper } from '../../helpers'


//#region Public Types

export const ROUTE_TRACKING_SERVICE_NAME = 'RouteTrackingService'
export const ROUTE_TRACKING_SERVICE_PROVIDER_NAME = 'RouteTrackingServiceProvider'

//#endregion


export class RouteTrackingService {


    //#region Costs

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Route.Tracking]' }

    //#endregion


    //#region Ctor

    constructor(private userSessionService: UserSessionService) { }

    //#endregion


    //#region Columns

    public getTrackingGridColumns(): ColumnModel[] {
        const timeColumn: ColumnModel = new ColumnModel()
        const eventNameColumn: ColumnModel = new ColumnModel()

        timeColumn.id = 1
        timeColumn.idName = 'time'
        timeColumn.name = 'Time'
        timeColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Time)
        timeColumn.width = 150

        eventNameColumn.id = 2
        eventNameColumn.idName = 'eventname'
        eventNameColumn.name = 'EventName'
        eventNameColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.EventType)

        return [timeColumn, eventNameColumn]
    }

    //#endregion

}

export class RouteTrackingServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        USER_SESSION_SERVICE_NAME, function (userSessionService: UserSessionService) {
            return new RouteTrackingService(userSessionService)
        }]

    //#endregion
} 